import React, { useMemo } from 'react';
import { useSelector } from "react-redux";
import { selectPermissions } from "../../../../util/store/selectors";
import { IVessel } from "../../../../util/varibles/interface";
import { ACTION } from "../../../../util/varibles/permission";
import Density from "../Density";

interface IProps {
    vessel: IVessel
}

const CombineDensity: React.FC<IProps> = ({ vessel }) => {
    const [canUpdateVessel] = useSelector(selectPermissions([ACTION.VESSEL.UPDATE]));

    const { density_map = {} } = vessel;
    const value = useMemo(() => Object.keys(density_map || {}).reduce((rs: string[], key) => {
        const value = key.split(',');
        return value.length > 1 ? [...rs, key] : rs;
    }, []), [density_map]);

    if (!canUpdateVessel)
        return null;

    return <div className='mt-4 flex flex-col gap-2'>
        <Density
            vessel={vessel}
            title={<div className='link font-[600] ml-[-10px]'>Define combined treatments’ density</div>}
            value={density_map}
        />
        <div className='flex flex-col gap-8px mt-2'>
            {value.map(item => {
                if (Object.keys(density_map[item]).length === 0)
                    return null;
                return <Density key={item} id={item} vessel={vessel} value={density_map} />
            })}
        </div>
    </div>;
};

export default CombineDensity;
